export const DEFAULT_OFFSET = 0;
export const DEFAULT_LIMIT = 100;
export const DEFAULT_ROWS_PER_PAGE = 10;
